import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { exchangeSession } from '../utils/api';

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, '')).get('session_id');
    if (!sessionId) {
      navigate('/admin/login', { replace: true });
      return;
    }
    exchangeSession(sessionId)
      .then((user) => {
        window.history.replaceState(null, '', location.pathname);
        navigate('/admin', { replace: true, state: { user } });
      })
      .catch(() => setError('Sign-in failed. Please try again.'));
  }, [location, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white px-4" data-testid="auth-callback-error">
        <div className="text-center space-y-4">
          <p className="text-gray-700">{error}</p>
          <button onClick={() => navigate('/admin/login', { replace: true })} className="text-[#D94B5A] underline" data-testid="auth-callback-retry">
            Back to sign in
          </button>
        </div>
      </div>
    );
  }
  return null;
};
